import React from "react";
import { SERVICE_FAQ } from "../../content/siteContent";

export const ServicesDetailsFaq = () => {
  return (
    <div className="accordion-wrap-three">
      <div className="accordion" id="accordionExample">
        {SERVICE_FAQ.map(([question, answer], index) => {
          const collapseId = `serviceFaq${index}`;
          return (
            <div key={question} className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${index ? "collapsed" : ""}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${collapseId}`}
                  aria-expanded={index === 0}
                  aria-controls={collapseId}
                >
                  {question}
                </button>
              </h2>
              <div
                id={collapseId}
                className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <p>{answer}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
